import { UiDefinition } from 'app/infrastructure/ui/types-uidefinition';
import { CaseData, CasePermissions } from 'app/types-shared';

export const ACTION = {
  REQUEST_CASE_ENTITY_ID: 'REQUEST_CASE_ENTITY_ID',
  RECEIVE_CASE_ENTITY_ID: 'RECEIVE_CASE_ENTITY_ID',
  FAIL_REQUEST_CASE_ENTITY_ID: 'FAIL_REQUEST_CASE_ENTITY_ID',
  REQUEST_CONNECTED_CASE_PERMISSIONS: 'REQUEST_CONNECTED_CASE_PERMISSIONS',
  RECEIVE_CONNECTED_CASE_PERMISSIONS: 'RECEIVE_CONNECTED_CASE_PERMISSIONS',
  REQUEST_CHANGE_CONNECTION_SEQUENCE: 'REQUEST_CHANGE_CONNECTION_SEQUENCE',
  RECEIVE_CHANGE_CONNECTION_SEQUENCE: 'RECEIVE_CHANGE_CONNECTION_SEQUENCE',
  FAIL_CHANGE_CONNECTION_SEQUENCE: 'FAIL_CHANGE_CONNECTION_SEQUENCE',
  RECEIVE_CASE: 'RECEIVE_CASE',
  FAIL_CASE_DATA: 'FAIL_CASE_DATA'
};

export class RequestCaseEntityId {
  public type: string = ACTION.REQUEST_CASE_ENTITY_ID;
  public caseId: number;

  constructor(caseId: number) {
    this.caseId = caseId;
  }
}

export class ReceiveCaseEntityId {
  public type: string = ACTION.RECEIVE_CASE_ENTITY_ID;
  public caseId: number;
  public entityId: number;

  constructor(caseId: number, entityId: number) {
    this.caseId = caseId;
    this.entityId = entityId;
  }
}

export class FailRequestCaseEntityId {
  public type: string = ACTION.FAIL_REQUEST_CASE_ENTITY_ID;
  public caseId: number;
  constructor(caseId: number) {
    this.caseId = caseId;
  }
}

export class RequestConnectedCasePermissions {
  public type: string = ACTION.REQUEST_CONNECTED_CASE_PERMISSIONS;
  constructor(public ids: number[]) { }
}

export class ReceiveConnectedCasePermissions {
  public type: string = ACTION.RECEIVE_CONNECTED_CASE_PERMISSIONS;
  constructor(public permissions: { [id: number]: CasePermissions }) { }
}

export class RequestChangeConnectionSequence {
  public type: string = ACTION.REQUEST_CHANGE_CONNECTION_SEQUENCE;
  constructor(public connectedCaseId: number) { }
}

export class ReceiveChangeConnectionSequence {
  public type: string = ACTION.RECEIVE_CHANGE_CONNECTION_SEQUENCE;
  constructor(public connectedCaseId: number) { }
}

export class FailChangeConnectionSequence {
  public type: string = ACTION.FAIL_CHANGE_CONNECTION_SEQUENCE;
  constructor(public connectedCaseId: number) { }
}

export class ReceiveCase {
  public type: string = ACTION.RECEIVE_CASE;
  public caseNumber: number;
  public data: CaseData;
  public uiDefinition: UiDefinition;

  constructor(caseNumber: number, data: CaseData, uiDefinition: UiDefinition) {
    this.caseNumber = caseNumber;
    this.data = data;
    this.uiDefinition = uiDefinition;
  }
}

export class FailLoadCase {
  public type: string = ACTION.FAIL_CASE_DATA;
}
